/**
 * Email template categories, as the backend lists them
 * (`EMAIL_TEMPLATE_CATEGORIES` in runtime/backend/server.py, served by
 * `GET /api/email-templates/categories`). Shared by the Campaign Builder's
 * template panel and Settings → Templates & Signatures (#955).
 */
export const EMAIL_TEMPLATE_CATEGORIES = [
    { value: 'general', label: 'General' },
    { value: 'introduction', label: 'Introduction' },
    { value: 'follow_up', label: 'Follow-up' },
    { value: 'meeting', label: 'Meeting Request' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'check_in', label: 'Check-in' },
    { value: 'thank_you', label: 'Thank You' },
    { value: 'cold_outreach', label: 'Cold Outreach' },
];
